/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BackgroundJobModel
 */
export interface BackgroundJobModel {
    /**
     * 
     * @type {number}
     * @memberof BackgroundJobModel
     */
    id: number;
}

export function BackgroundJobModelFromJSON(json: any): BackgroundJobModel {
    return BackgroundJobModelFromJSONTyped(json, false);
}

export function BackgroundJobModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BackgroundJobModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function BackgroundJobModelToJSON(value?: BackgroundJobModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

